'use client';

import {createContext, type FC, memo, type PropsWithChildren, type ReactElement, useEffect, useState} from 'react';

export const BroadcastChannelContext = createContext<BroadcastChannel | null>(null);

export const BroadcastChannelProvider: FC<PropsWithChildren<unknown>> = memo(({children}): ReactElement | null => {
  const [bc, setBc] = useState<BroadcastChannel | null>(null);

  useEffect(() => {
    if (typeof window !== 'undefined' && 'BroadcastChannel' in window) {
      const channel = new BroadcastChannel('main');
      setBc(channel);
      return () => channel.close();
    }
  }, []);

  return <BroadcastChannelContext.Provider value={bc}>{children}</BroadcastChannelContext.Provider>;
});

BroadcastChannelProvider.displayName = 'BroadcastChannelProvider';
